import Influencers from './dumb.js';
import enhance from './enhancer';

export default enhance(Influencers);
